const KEY_PIOCHE_SIDE = "pioche_side";

export const getPiocheSide = () => localStorage.getItem(KEY_PIOCHE_SIDE) || "right";
export const setPiocheSide = (side) => localStorage.setItem(KEY_PIOCHE_SIDE, side);
